export default __webpack_public_path__ + "static/media/right-side-login.0e07782c.png";